import axios from "axios";
import * as env from "../config/env";
const baseUrl = `${env.url}/stats/op`;
const OP_URL = `${env.OpBarcodeUrl}`;
const OP_USER_TOKEN = `${env.OP_USER_TOKEN}`;

const headers = {
  "User-Token": env.userToken,
};

const opHeaders = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'OP-USER-TOKEN': OP_USER_TOKEN
}

let reprintServer = 'http://localhost:9000/api/orders';

export function getOrders() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/orders`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrderItems() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/orderItems`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrdersBySku() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/ordersBySku`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getCanceledOrders() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/canceled`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrdersDueToday() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/dueToday?day=${"today"}&facility=${"fm"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrdersDueTmrw() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/dueToday?day=${"tmrw"}&facility=${"fm"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getItemsDueToday() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/itemsDue?day=${"today"}&facility=${"fm"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getItemsDueTmrw() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/itemsDue?day=${"tmrw"}&facility=${"fm"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getLateOrders() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/lateOrders?facility=${"fm"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getLateOrdersReport({ search = '', page = 1, per_page = 50, facility = 'fm' } = {}) {
  const config = {
    method: "GET",
    headers
  };
  const params = new URLSearchParams({
    search,
    page: String(page),
    per_page: String(per_page),
    facility,
  });
  return axios
    .get(`${baseUrl}/lateOrdersReport?${params.toString()}`, config)
    .then(responseSuccessHandler)
    .catch(responseErrorHandler);
}

export function getOpenOrdersSummary(facility = 'fm') {
  const config = {
    method: "GET",
    headers
  };
  return axios
    .get(`${baseUrl}/orderSummary?facility=${facility}`, config)
    .then(responseSuccessHandler)
    .catch(responseErrorHandler);
}

// Sensitive — the backend independently checks User-Email against an allowed
// list (see require_shipping_performance_access in OpOrdersApi.py); this call
// will 403 for anyone not on that list even if they reach this code path.
export function getShippingPerformance(date = null) {
  const config = {
    method: "GET",
    headers: {
      ...headers,
      "User-Email": localStorage.getItem("UserEmail") || "",
    },
  };
  const params = date ? `?date=${encodeURIComponent(date)}` : "";
  return axios
    .get(`${baseUrl}/shippingPerformance${params}`, config)
    .then(responseSuccessHandler)
    .catch(responseErrorHandler);
}

// Combined endpoint backing both the Mug Box and Puzzle Box Requirements
// cards from a single request — they scan the same order data, so this
// replaced two separate near-duplicate calls (see OpBoxRequirementsHandler).
// Response shape: { mug: { dates: [...] }, puzzle: { dates: [...] } }.
export function getBoxRequirements(facility = "fm") {
  const config = {
    method: "GET",
    headers,
  };
  return axios
    .get(`${baseUrl}/boxRequirements?facility=${facility}`, config)
    .then(responseSuccessHandler)
    .catch(responseErrorHandler);
}

function fetchOrdersReport(endpoint, { search = '', page = 1, per_page = 50, facility = 'fm', skus = null, date = null, box_size = null } = {}) {
  const config = {
    headers
  };
  const payload = {
    search,
    page,
    per_page,
    facility,
  };
  // When a product category is selected, the page passes the category's SKUs so the
  // backend can filter (and paginate/count) across the whole dataset. Keep these in
  // the POST body instead of the query string; large categories can contain hundreds
  // of SKUs and create URLs that browsers/proxies reject.
  if (Array.isArray(skus) && skus.length) {
    payload.skus = skus;
  }
  // Narrows the Mug Box Requirements detail tab to a single due date/box size.
  if (date) {
    payload.date = date;
  }
  if (box_size) {
    payload.box_size = box_size;
  }
  return axios
    .post(`${baseUrl}/${endpoint}`, payload, config)
    .then(responseSuccessHandler)
    .catch(responseErrorHandler);
}

export function getTotalLateOrdersReport(options = {}) {
  return fetchOrdersReport('totalLateOrders', options);
}

export function getTodaysOrdersReport(options = {}) {
  return fetchOrdersReport('todaysOrders', options);
}

export function getLateItems() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/lateItems?facility=${"fm"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getInventory() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/inventory`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrdersShipped() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/ordersShipped?facility=${"fm"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getItemsShipped() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/itemsShipped?facility=${"fm"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getArtwork(barcode) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/artwork?barcode=${barcode}&token=${OP_USER_TOKEN}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getShipErrors(options = {}) {
  return fetchOrdersReport('shipErrors', options);
}

export function getShippedTodayReport(options = {}) {
  return fetchOrdersReport('shippedToday', options);
}

// export function getIncomingOrdersReport(options = {}) {
//   return fetchOrdersReport('incomingOrders', options);
// }

export function getAllOpOrdersReport(options = {}) {
  return fetchOrdersReport('allOrders', options);
}

export function getDueNextBusinessDayReport(options = {}) {
  return fetchOrdersReport('dueNextBusinessDay', options);
}

export function getMugBoxOrdersReport(options = {}) {
  return fetchOrdersReport('mugBoxOrders', options);
}

export function getPuzzleBoxOrdersReport(options = {}) {
  return fetchOrdersReport('puzzleBoxOrders', options);
}

export function getShipErrorsLegacy() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/shipError`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrderCycle() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/cycle`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getMixedOrderCycle(data) {
  const config = {
    method: "POST",
    headers,
    data
  };
  return axios.post(`${baseUrl}/mixedCycle`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getPrelimLines(timeFrame) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/lines?time=${timeFrame}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getPopularLocation(timeFrame, location) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/locations?time=${timeFrame}&location=${location}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getSkuStats() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/skuStats`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getSkuShipped(data) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/skuShipped?time=${data.time}&sku=${data.sku}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getShippingLines(timeFrame) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/shippingLines?time=${timeFrame}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getPrelimItemLines(timeFrame) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/itemLines?time=${timeFrame}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

// export function getArtworkLocal(barcode) {
//   const config = {
//     method: "GET",
//     opHeaders
//   };
//   return axios.get(`${reprintServer}/${barcode}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
// }

export function getSplomSetup() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/splomSetup`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getDailyReport() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/dailyReport?facility=${"fm"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getPopularSku(timeFrame) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/popularSku?time=${timeFrame}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getCompanySku(timeFrame, company) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/companySku?time=${timeFrame}&company=${company}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getRevenue(timeFrame) {
  const config = {
    method: "GET",
    headers
  }
  return axios.get(`${baseUrl}/revenue?time=${timeFrame}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getFm_Ky() {
  const config = {
    method: "GET",
    headers
  }
  return axios.get(`${baseUrl}/FmKy`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

const responseSuccessHandler = response => {
  return response.data;
};
  
const responseErrorHandler = error => {
  console.log(error);
  return Promise.reject(error);
};
